import { environment } from '@env/environment';
import { MenuItemModel } from '@shared/models/menu.model';
import { MenuRoles } from './menu-roles';

export const SharedMenus: MenuItemModel[] = [
  {
    name: 'SHARED_MENU.USER_INFO',
    route: environment.tempUrl + '/settings/userInfo',
    order: 1,
    icon: 'i-header-personalInfo',
    externalUrl: true
  },
  {
    name: 'SHARED_MENU.MY_COMPANY',
    route: environment.tempUrl + '/settings/company',
    order: 2,
    icon: 'i-header-company',
    externalUrl: true
  },
  {
    name: 'SHARED_MENU.MY_FACILITIES',
    route: environment.tempUrl + '/settings/MyFacilities',
    order: 3,
    icon: 'i-header-facilities',
    externalUrl: true
  },
  {
    name: 'SHARED_MENU.MY_DEVICES',
    route: environment.tempUrl + '/settings/devices',
    order: 4,
    icon: 'i-header-devices',
    externalUrl: true
  },
  {
    name: 'SHARED_MENU.CONFIG_PARAMETERS',
    route: environment.tempUrl + '/settings/configParameters',
    order: 5,
    icon: 'i-header-gears',
    role: MenuRoles.ConfigParamter,
    externalUrl: true
  },
  {
    name: 'SHARED_MENU.LICENSE_CENTER',
    route: environment.tempUrl + '/settings/licenseCenter',
    order: 6,
    icon: 'i-header-licensecenter',
    role: MenuRoles.LicenseCenter,
    externalUrl: true
  },
  {
    name: 'SHARED_MENU.MY_LICENSES',
    route: environment.tempUrl + '/settings/licenses',
    order: 7,
    icon: 'i-header-license',
    role: MenuRoles.Licenses,
    externalUrl: true
  },
  {
    name: 'SHARED_MENU.LICENSE_USAGE',
    route: environment.tempUrl + '/settings',
    order: 8,
    icon: 'i-header-settings',
    role: MenuRoles.Settings,
    externalUrl: true
  },
  {
    name: 'SHARED_MENU.TARIFFS',
    route: environment.tempUrl + '/settings/tariffList',
    order: 9,
    icon: 'i-header-tariffs',
    externalUrl: true
  },
  {
    name: 'SHARED_MENU.PRODUCTS',
    route: '/settings/products',
    order: 10,
    icon: 'i-icon-product'
  },
  {
    name: 'SHARED_MENU.DEVELOPER',
    route: environment.tempUrl + '/settings/developerList',
    order: 11,
    icon: 'i-header-developer',
    specificRole: 'Developer',
    role: MenuRoles.Developer,
    externalUrl: true
  },
  {
    name: 'SHARED_MENU.USERS',
    route: environment.tempUrl + '/settings/users/list',
    order: 12,
    icon: 'i-header-users',
    role: MenuRoles.Users,
    externalUrl: true
  },
  {
    name: 'SHARED_MENU.USER_ALARMS',
    route: environment.tempUrl + '/settings/users/alarms',
    order: 13,
    icon: 'i-header-user-alarms',
    role: MenuRoles.UserAlarm.roles,
    licenceType: MenuRoles.UserAlarm.licenceType,
    externalUrl: true
  },
  {
    name: 'SHARED_MENU.SUPPORT',
    route: environment.tempUrl + '/support',
    order: 14,
    icon: 'i-header-support',
    externalUrl: true
  },
  {
    name: 'SHARED_MENU.DOWNLOAD',
    route: environment.tempUrl.replace('/?', '') + '/download/ENTES.NET.msi',
    order: 15,
    icon: 'i-header-download',
    role: MenuRoles.Download.roles,
    licenceType: MenuRoles.Download.licenceType,
    externalUrl: true,
    isHideAside: true
  },
  {
    name: 'SHARED_MENU.LOGOUT',
    route: environment.tempUrl + '/settings/logout',
    order: 16,
    icon: 'i-header-exit',
    event: 'logout',
    isHideAside: true
  },
];
